/* Mood & Life · ventanas emergentes con los formularios de Hostelería, Supermercado y Hoteles (15 oct 2026). Tema y prototipo.
   - Abre la ventana desde cualquier enlace a #form-hosteleria, #form-supermercado o a la página de hoteles con #formulario
     (también los reescritos por la vista previa: ?view=ml-hoteles#formulario). Sin JavaScript, el enlace va a su página.
   - Cierre con la X, Escape y clic fuera; <dialog> modal (foco atrapado), el foco vuelve al botón y el fondo no se mueve.
   - Al volver de Shopify (?contact_posted=true#f-ok-…-v) o con errores del envío, reabre la ventana del formulario enviado. */
(function () {
  var dlgs = [].slice.call(document.querySelectorAll('dialog.ml-dlg-form'));
  if (!dlgs.length || typeof dlgs[0].showModal !== 'function') return;
  var origen = null;
  function cual(a) {
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || !u.hash) return null;
    var h = u.hash.slice(1);
    return dlgs.filter(function (d) {
      if (d.getAttribute('data-ancla') !== h) return false;
      var p = d.getAttribute('data-pagina');
      return !p || u.pathname.indexOf('/' + p) > -1 || u.search.indexOf('ml-' + p) > -1 || /\/hoteles(\.html)?$/.test(u.pathname) && p === 'hoteles';
    })[0] || null;
  }
  function abre(d, desde) {
    origen = desde || null;
    dlgs.forEach(function (x) { if (x.open) x.close(); });
    document.documentElement.classList.add('ml-dlg-abierto');
    d.showModal(); d.querySelector('.ml-dlg-cuerpo').scrollTop = 0;
    var c = d.querySelector('form input:not([type=hidden]):not([tabindex="-1"]), form select, form textarea');
    (c || d.querySelector('[data-cerrar]')).focus();
  }
  dlgs.forEach(function (d) {
    d.addEventListener('close', function () { document.documentElement.classList.remove('ml-dlg-abierto'); if (origen && document.contains(origen)) origen.focus(); origen = null; });
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-cerrar]')) d.close(); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.closest('dialog') || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var d = cual(a); if (!d) return;
    e.preventDefault(); e.stopPropagation(); abre(d, a);
  }, true);   // captura: antes que el desplazamiento suave a anclas de ml.js (en la vista previa todas las páginas comparten ruta)
  // vuelta de Shopify: aviso de "Recibido" o errores dentro de la ventana
  var h = location.hash.slice(1), posted = /contact_posted=true/.test(location.search);
  dlgs.forEach(function (d) {
    var f = d.querySelector('form');
    if (f && h && f.id === h && (posted || f.querySelector('.err[role=alert]'))) abre(d, null);
  });
  window.mlDialogoForm = { abre: abre };
})();
